"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchNotificationsData = exports.getNotifications = exports.parseNotificationData = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _get = _interopRequireDefault(require("lodash/get"));

var _keyBy = _interopRequireDefault(require("lodash/keyBy"));

var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));

var _NotificationsConfigFetcher = _interopRequireDefault(require("./NotificationsConfigFetcher"));

var Constants = _interopRequireWildcard(require("../constants/Constants"));

var NotificationsSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _Reminders = require("../actions/Reminders");

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/*
  * parseNotificationData(data, pulseApiHelper, store) is to parse the response
  * received from ANS API for notifications and act upon the type of notification
  * accordingly
  */
var parseNotificationData =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(data, store) {
    var notifications, serverTimestamp, parsedNotifications, newNotifications, reminders, updatedNotifications, latestNotificationTimestamp, i, notification, notificationsById, _notificationsById;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            notifications = (0, _get.default)(data, 'notifications');
            serverTimestamp = (0, _get.default)(data, 'server-timestamp');
            notifications = (0, _get.default)(notifications, 'notification', []);
            parsedNotifications = [];
            notifications.forEach(
            /*#__PURE__*/
            function () {
              var _ref2 = (0, _asyncToGenerator2.default)(
              /*#__PURE__*/
              _regenerator.default.mark(function _callee(notification) {
                var parsedNotification;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (!(notification.type == 'com.adobe.ans.system.v1')) {
                          _context.next = 4;
                          break;
                        }

                        _context.next = 3;
                        return store.dispatch({
                          type: types.MARK_ALL_NOTIFICATION_AS_READ
                        });

                      case 3:
                        return _context.abrupt("return");

                      case 4:
                        parsedNotification = _PulseApiHelper.default.createPulseMessageObject(notification);

                        if (parsedNotification !== null) {
                          parsedNotifications.push(parsedNotification);
                        }

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()); //Notification poll would receive data in all these cases
            //1. An update happened to a notification (mark as read/payload change, metadata change?)
            //2. Could be a new notification
            //3. Could be a reminder getting fired
            //4. System generated nottification

            newNotifications = [], reminders = [], updatedNotifications = [];
            latestNotificationTimestamp = NotificationsSelectors.getLatestNotificationTimestamp(store.getState());

            for (i = 0; i < parsedNotifications.length; ++i) {
              notification = parsedNotifications[i]; //the below conditions filter the incoming notifications into 3 categories
              //1. Brand new notifications
              //2. Updates to exisiting notifications
              //3. Reminders on the exisiting notifications
              //4. System generated notifications
              //simplest case is the new notifications

              if (notification.createdTimestamp > latestNotificationTimestamp) {
                newNotifications.push(notification);
              } else {
                //if reminderTime key exists in the notification, this update could be
                //1. A general update
                //2. Reminder fire
                if ('reminderTime' in notification) {
                  if (notification.reminderTime > serverTimestamp) {
                    //if the reminderTime is still greater than the time on the server, it means the update is a general update (like mark as read)
                    updatedNotifications.push(notification);
                  } else {
                    reminders.push(notification);
                  }
                } else {
                  //No reminders have been set on this notification, so it is a general update
                  updatedNotifications.push(notification);
                }
              }
            }

            if (!(newNotifications.length > 0)) {
              _context2.next = 12;
              break;
            }

            //dispatch action to the store
            notificationsById = (0, _keyBy.default)(newNotifications, function (notification) {
              return notification.id;
            });
            _context2.next = 12;
            return store.dispatch({
              type: types.LONG_POLL_NOTIFICATIONS_FETCHED,
              notificationsById: notificationsById
            });

          case 12:
            if (!(updatedNotifications.length > 0)) {
              _context2.next = 16;
              break;
            }

            _notificationsById = (0, _keyBy.default)(updatedNotifications, function (notification) {
              return notification.id;
            });
            _context2.next = 16;
            return store.dispatch({
              type: types.NOTIFICATIONS_UPDATED,
              notificationsById: _notificationsById
            });

          case 16:
            if (!(reminders.length > 0)) {
              _context2.next = 21;
              break;
            }

            _context2.next = 19;
            return store.dispatch({
              type: types.REMINDERS_FETCHED,
              reminders: reminders
            });

          case 19:
            _context2.next = 21;
            return reminders.forEach(function (reminder) {
              store.dispatch((0, _Reminders.removeReminder)(reminder));
            });

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function parseNotificationData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/*
  * getNotifications(store) is to make the call to ANS API
  * to fetch the notifications
  */


exports.parseNotificationData = parseNotificationData;

var getNotifications =
/*#__PURE__*/
function () {
  var _ref3 = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(store) {
    var response;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _NotificationsConfigFetcher.default.fetchNotificationsData(store);

          case 2:
            response = _context3.sent;

            if (!(response && !response.error)) {
              _context3.next = 6;
              break;
            }

            _context3.next = 6;
            return parseNotificationData(response.data, store);

          case 6:
            return _context3.abrupt("return", response);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getNotifications(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

exports.getNotifications = getNotifications;

var checkAndStopPolling = function checkAndStopPolling(response, notificationPollingIntervalId) {
  if (response.error && response.error.status >= 400 && response.error.status <= 404) {
    clearInterval(notificationPollingIntervalId);
  }
};

var fetchNotificationsData = function fetchNotificationsData(store) {
  var notificationPollingIntervalId;

  function fetchData() {
    return _fetchData.apply(this, arguments);
  }

  function _fetchData() {
    _fetchData = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee4() {
      var response;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return getNotifications(store);

            case 2:
              response = _context4.sent;
              checkAndStopPolling(response, notificationPollingIntervalId);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _fetchData.apply(this, arguments);
  }

  ;
  return {
    start: function start() {
      notificationPollingIntervalId = window.setInterval(fetchData, Constants.NOTIFICATION_POLL_INTERVAL_TIME);
    },
    stop: function stop() {
      clearInterval(notificationPollingIntervalId);
    }
  };
};

exports.fetchNotificationsData = fetchNotificationsData;
var _default = {
  fetchNotificationsData: fetchNotificationsData,
  getNotifications: getNotifications,
  parseNotificationData: parseNotificationData
};
exports.default = _default;